import { WalletCard } from '@givebacks/api/backer';

import { AccountCardPage } from '../components/AccountCardPage/AccountCardPage';

const filterMembershipCards = (data: WalletCard[]) =>
  data.filter((card) => Boolean(card.membership));
const getMembershipKey = (card: WalletCard) => card.membership?.uuid;

const MembershipPage = () => {
  return (
    <AccountCardPage
      title="Membership Cards"
      filterFn={filterMembershipCards}
      getKey={getMembershipKey}
      noDataMessage={{
        title: "You don't have any membership cards yet.",
        message:
          "Browse your organization's page to purchase a membership, and you'll see your membership cards here.",
      }}
    />
  );
};

export { MembershipPage };
